import React from 'react'

export default ({ children }) => (
  <div>{children}</div>
)
